module.exports = __webpack_public_path__ + "img/03.2ab3edc1.jpg";